<template>
	<div class="relative flex flex-col items-center">
		<slot />
		<Transition
			enterActiveClass="transition-opacity duration-500"
			leaveActiveClass="transition-opacity duration-500"
			enterFromClass="opacity-0"
			leaveToClass="opacity-0"
		>
			<div class="absolute top-2 right-5 left-5 h-29" v-if="modelUuid">
				<svg
					width="100%"
					height="100%"
					viewBox="0 0 141 108"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="block object-cover"
					preserveAspectRatio="xMidYMid slice"
				>
					<mask
						id="mask0_374_6249"
						style="mask-type: alpha"
						maskUnits="userSpaceOnUse"
						x="0"
						y="-4"
						width="141"
						height="116"
					>
						<rect
							x="140.75"
							y="112"
							width="140"
							height="116"
							transform="rotate(180 140.75 112)"
							fill="url(#paint0_radial_374_6249)"
						/>
					</mask>
					<g mask="url(#mask0_374_6249)">
						<path
							opacity="0.1"
							d="M-407.74 -25.98H645.319V-24.0034H-407.74V-25.98ZM-407.74 -7.25244H645.319V-5.27588H-407.74V-7.25244ZM-407.74 2.11182H645.319V4.08936H-407.74V2.11182ZM-407.74 11.4771H645.319V13.4536H-407.74V11.4771ZM-407.74 20.8403H645.319V22.8169H-407.74V20.8403ZM-407.74 30.2046H645.319V32.1812H-407.74V30.2046ZM-407.74 39.5698H645.319V41.5464H-407.74V39.5698ZM-407.74 48.9341H645.319V50.9106H-407.74V48.9341ZM-407.74 58.2974H645.319V60.2739H-407.74V58.2974ZM-407.74 67.6616H645.319V69.6392H-407.74V67.6616ZM-407.74 77.0269H645.319V79.0034H-407.74V77.0269ZM-407.74 86.3921H645.319V88.3687H-407.74V86.3921ZM-407.74 95.7554H645.319V97.7329H-407.74V95.7554ZM-407.74 105.121H645.319V107.097H-407.74V105.121Z"
							fill="#878787"
						/>
					</g>
					<defs>
						<radialGradient
							id="paint0_radial_374_6249"
							cx="0"
							cy="0"
							r="1"
							gradientUnits="userSpaceOnUse"
							gradientTransform="translate(210.75 170) rotate(180) scale(70 57.8513)"
						>
							<stop offset="0.246979" stop-color="#0A1119" />
							<stop offset="1" stop-color="#33567F" stop-opacity="0" />
						</radialGradient>
					</defs>
				</svg>
			</div>
		</Transition>
		<div
			class="relative aspect-square w-full"
			:class="{ 'opacity-30 grayscale-100': disabled }"
		>
			<Transition
				enterActiveClass="transition-transform duration-500"
				leaveActiveClass="transition-transform duration-500"
				enterFromClass="scale-0"
				leaveToClass="scale-0"
			>
				<div class="absolute inset-5 flex items-center justify-center">
					<LazyImage
						v-if="modelUuid"
						:src="icon(modelUuid)"
						alt="drop"
						class="max-h-50 max-w-50"
					/>
				</div>
			</Transition>
			<Transition
				enterActiveClass="transition-transform duration-500"
				leaveActiveClass="transition-transform duration-500"
				enterFromClass="scale-0"
				leaveToClass="scale-0"
			>
				<div
					class="absolute flex items-center justify-center"
					:class="{
						'inset-0': centered,
						'top-0 -right-2 bottom-0 left-2': !centered
					}"
				>
					<LazyImage
						v-if="!modelUuid"
						:src="caseIcon(uuid)"
						:alt="name"
						class="max-h-50 max-w-50"
					/>
				</div>
			</Transition>
		</div>
		<div class="text-label-secondary -mt-3 truncate text-center text-sm">
			{{ name }}
		</div>
		<CoinPrice class="mt-2" :price="price" v-if="price" />
	</div>
</template>
<script setup lang="ts">
import LazyImage from './LazyImage.vue'
import CoinPrice from './CoinPrice.vue'
import { caseIcon, icon } from '@/utils/urls'

defineProps<{
	alt?: boolean
	name: string
	uuid: string
	modelUuid?: string
	price?: number
	disabled?: boolean
	centered?: boolean
}>()
</script>
